import { render, staticRenderFns } from "./DontMiss.vue?vue&type=template&id=39f52264&"
import script from "./DontMiss.vue?vue&type=script&lang=js&"
export * from "./DontMiss.vue?vue&type=script&lang=js&"
import style0 from "./DontMiss.vue?vue&type=style&index=0&id=39f52264&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports